export default __webpack_public_path__ + "static/media/3145.cd507427.jpg";